export const BACKEND_URL = "/api/";

export const FONTS = [
    'Archivo', 'Arvo', 'Be Vietnam Pro', 'Black Han Sans', 'Cabin',
    'Teachers', 'HK Grotesk', 'Kumbh Sans', 'Manrope',
    'Noto Sans SC', 'Noto Serif', 'Open Sans', 'Orelega One', 'Orienta',
    'Oswald', 'Overpass', 'PT Root UI', 'Pacifico', 'Quicksand',
    'Recursive', 'Roboto', 'Secular One', 'Sora', 'Stoke', 'VT323',
    'Yellowtail', 'Zilla Slab', 'Bubblegum Sans', 'DM Sans', 'Seaweed Script',
    'Lexend Deca'
];

export const FONTS_WITHOUT_BOLD = [
    'HK Grotesk', 'Orienta', 'Pacifico',
    'Stoke', 'VT323', 'Yellowtail', 'Bubblegum Sans', 'Seaweed Script', 'Lexend Deca'
];

export const FONTS_URL = "https://fonts.googleapis.com/css2?family=Archivo:wght@400;700&family=Arvo:wght@400;700&family=Be+Vietnam+Pro:wght@400;700&family=Black+Han+Sans&family=Cabin:wght@400;700&family=Teachers&family=HK+Grotesk&family=Kumbh+Sans:wght@400;700&family=Manrope:wght@400;700&family=Noto+Sans+SC:wght@400;700&family=Noto+Serif:wght@400;700&family=Open+Sans:wght@400;700&family=Orelega+One&family=Orienta&family=Oswald:wght@400;700&family=Overpass:wght@400;700&family=PT+Root+UI:wght@400;700&family=Pacifico&family=Quicksand:wght@400;700&family=Recursive:wght@400;700&family=Roboto:wght@400;700&family=Secular+One&family=Sora:wght@400;700&family=Stoke&family=VT323&family=Yellowtail&family=Zilla+Slab:wght@400;700&family=Bubblegum+Sans&family=DM+Sans:wght@400;700&family=Seaweed+Script&family=Lexend+Deca:wght@400;700&display=swap";